<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Kwiff_Field_Url')"
        prop="params.url"
      >
        <el-input v-model="model.params.url" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Kwiff_Field_Login')"
        prop="params.login"
      >
        <el-input v-model="model.params.login" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Kwiff_Field_Password')"
        prop="params.password"
      >
        <el-input v-model="model.params.password" />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'KwiffSettings',
  components: {
    FormSection,
    RestFormItem
  },
  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          url: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          login: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          password: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      }
    }
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/kwiff/KwiffSettings.vue